import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    clientId: Yup.number().nullable().required("Please select a client"),
    locationId: Yup.number().nullable().required("Please select a client location"),
    contactName: Yup.string().required('Please enter contact name'),
    contactPhone: Yup.string().nullable(),
    contactEmail: Yup.string().nullable().email("Please enter a valid email"),
    projectName: Yup.string().nullable().required("Please enter a project name"),
    projectTypeId: Yup.number().nullable().required("Please select a project type"),
    projectSubTypeId: Yup.number().nullable().required("Please select a project sub type"),
    description: Yup.string().nullable(),
    expirationDate: Yup.string().required("Please select an expiration date"),
    referralSourceId: Yup.number().nullable().required("Please select a referral"),
    projectLocation: Yup.string().nullable(),
    proposalProjectLocations: Yup.array().min(1, "Please add at least one location"),
});